import { Badge, Box, Text, TextButton } from '@wix/design-system';
import React from 'react';
import { ElementStatus } from '../../../../..';
import { AiSectionHelper } from '../ai-flow/ai-section-helper';
import { HeadingStructureRuleGenericTimeline } from './heading-structure-rule-generic-timeline';
import { HeadingStructureRuleGenericGeneratedState } from './heading-structure-rule-genric-generated-state';
export const HeadingStructureRuleGenericContent = _ref => {
  var _texts$dropdownOption;
  let {
    elementIndex,
    headingDefinition,
    aiProposedDefinition,
    status,
    texts,
    callbacks,
    failedReason,
    isAiSuggested,
    timelineTransComponents
  } = _ref;
  const shouldShowTimelineOnCompletion = texts.timeline.timeline.success === undefined;
  const handleLearnMoreClick = () => {
    callbacks.onLearnMoreClick({
      index: elementIndex,
      status
    });
  };
  const shouldShowDescription = shouldShowTimelineOnCompletion || status === ElementStatus.Failed || !!isAiSuggested;
  const suggestionSource = aiProposedDefinition ?? headingDefinition;
  const resolvedSuggestion = ((_texts$dropdownOption = texts.dropdownOptions.find(opt => opt.id === suggestionSource.toLowerCase())) == null ? void 0 : _texts$dropdownOption.label) ?? suggestionSource;
  const hasUnresolvedAiSuggestion = !!isAiSuggested && suggestionSource.toLowerCase() !== headingDefinition.toLowerCase();
  const aiSectionHelperTexts = {
    aiSuggestionLabel: texts.genericAiComponentTitle,
    suggestion: texts.genericAiSuggestion
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, hasUnresolvedAiSuggestion && /*#__PURE__*/React.createElement(AiSectionHelper, {
    suggestion: resolvedSuggestion,
    texts: aiSectionHelperTexts
  }), shouldShowDescription && /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, texts.genericContentText, /*#__PURE__*/React.createElement(TextButton, {
    as: "a",
    size: "tiny",
    skin: "dark",
    target: "_blank",
    underline: "always",
    onClick: handleLearnMoreClick
  }, texts.learnMoreText)), /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "B60",
    borderRadius: "6px",
    direction: "vertical",
    gap: "SP2",
    padding: shouldShowTimelineOnCompletion && status === ElementStatus.Passed ? '0 SP2 SP2 SP2' : '9px 0 29px SP2 '
  }, (!shouldShowTimelineOnCompletion || shouldShowTimelineOnCompletion && status === ElementStatus.Failed) && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    padding: "SP2 0 0 SP2"
  }, /*#__PURE__*/React.createElement(Badge, {
    noPadding: true,
    showTooltip: false,
    size: "tiny",
    skin: "neutralStandard",
    type: "solid",
    uppercase: false
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "0 4px"
  }, texts.genericBadgeText))), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, !!isAiSuggested && texts.timeline.generatedState ? /*#__PURE__*/React.createElement(HeadingStructureRuleGenericGeneratedState, {
    aiSuggestion: resolvedSuggestion,
    formatAiSuggestion: texts.genericAiSuggestion,
    showAiSuggestion: hasUnresolvedAiSuggestion,
    texts: texts.timeline.generatedState,
    transComponents: timelineTransComponents
  }) : /*#__PURE__*/React.createElement(HeadingStructureRuleGenericTimeline, {
    failedReason: failedReason,
    status: status,
    texts: texts.timeline,
    transComponents: timelineTransComponents
  }))));
};
//# sourceMappingURL=heading-structure-rule-generic-content.js.map